import { spLog } from '@eventr/common'
import React from 'react'
import { BoldText } from './BoldText'
import { ItalicText } from './ItalicText'
import { PlainText } from './PlainText'
import { StrikeText } from './StrikeText'

export const LinkText = (content: any) => {
    const href = content.href

    const link = React.useMemo(() => {
        const labelArray = Array.isArray(content.label)
            ? content.label
            : [content.label]

        const labelElements = labelArray.map((content: any, index: number) => {
            switch (content.type) {
                case 'PLAIN_TEXT':
                    return <PlainText key={index} contents={content.value} />

                case 'STRIKE':
                    return <StrikeText key={index} contents={content.value} />

                case 'ITALIC':
                    return <ItalicText key={index} contents={content.value} />

                case 'BOLD':
                    return <BoldText key={index} contents={content.value} />

                default:
                    return null
            }
        })

        return labelElements
    }, [content.label])

    const revisedHref = () => {
        if (href.toLocaleLowerCase().includes('https://')) {
            return href
        } else {
            return 'https:' + href
        }
    }

    return (
        <span
            style={{
                cursor: 'pointer',
                color: 'blue',
                textDecoration: 'underline',
            }}
            onClick={(e) => {
                spLog('open link: ', revisedHref())
                e.stopPropagation()
                window.open(revisedHref(), '_system')
            }}
        >
            {link}
        </span>
    )
}
